import { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.scss';

export type ButtonProps = {
  text: string;
  color: string;
  action?: () => void;
  icon?: string;
  iconPosition?: 'left' | 'right';
  size?: 'small' | 'normal' | 'large';
  border?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({
  text,
  action,
  color,
  disabled = false,
  icon,
  iconPosition = 'left',
  size = 'normal',
  border = true,
  ...otherProps
}: ButtonProps) => {
  const buttonClasses = `${styles.button} ${styles[color]} ${styles[size]} ${
    border ? styles['with-border'] : ''
  }`;

  return (
    <button className={buttonClasses} disabled={disabled} onClick={action} {...otherProps}>
      {iconPosition === 'left' && icon && (
        <div className={`${styles['icon-container']} ${styles['icon-left']}`}>
          <img src={icon} alt="Icon" className={styles['icon']} />
        </div>
      )}
      {text}
      {iconPosition === 'right' && icon && (
        <div className={`${styles['icon-container']} ${styles['icon-right']}`}>
          <img src={icon} alt="Icon" className={styles['icon']} />
        </div>
      )}
    </button>
  );
};

export default Button;
